import React from 'react';
import { intlShape, injectIntl } from 'react-intl';
import randomstring from 'uuid/v4';

import NavigateAfter from '@material-ui/icons/NavigateNext';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

class ExpandFamily extends React.Component {

    state = {
        expand: true
    }

    getResumenInstancias = (instancias) => {
        return [...instancias]
            .map((i) => {
                return {
                    id: i.id,
                    local: i.local,
                    nlocal: i.nlocal,
                    ntrabajador: i.ntrabajador,
                    fecha: i.fecha,
                    fuerarango: i.campos.reduce((fuerarango, c1) => {
                        if (c1.campos) {
                            return fuerarango || c1.campos.reduce((fuerarango, c2) => {
                                if (c2.campos) {
                                    return fuerarango || c2.campos.reduce((fuerarango, c) => {
                                        return fuerarango || c.alerta;
                                    }, false)
                                }
                                return fuerarango || c2.alerta;
                            }, false)
                        }
                        return fuerarango || c1.alerta;
                    }, false)
                }
            });
    }


    handleDetail = (id) => {
        this.props.history.push(`/reports/employee/detail/${id}`)
    }

    render() {
        const { intl, family, process, hide } = this.props;
        const { expand } = this.state;
        const data = process.instancias && process.instancias.length >0 ? this.getResumenInstancias(process.instancias).sort((a, b) => a.fecha > b.fecha ? 1 : -1) : [];
        console.log(data);
        return (
            <div
                key={randomstring()}
                className="flex_auto_column margin_bottom_12">
                <div className="flex_auto_row padding_borders_flat bg_light_purple_40 c_slate uppercase center margin_bottom_12">
                    {expand
                        ? <ExpandLess className="hand c_slate" onClick={() => { this.setState({ expand: !expand }) }} />
                        : <ExpandMore className="hand c_slate" onClick={() => { this.setState({ expand: !expand }) }} />
                    }
                    <span className="flex_full_row">{process.nombre}</span>
                    <div className="flex_auto_row align_center hand nowrap" onClick={() => this.handleDetail(process.codigo)}>
                        <div className="barlow_regular_small c_slate">
                            {intl.formatMessage({ id: 'report_employee_details_button' })}
                        </div>
                        <NavigateAfter className="c_slate" />
                    </div>
                </div>
                <div className="flex_auto_row wrap">
                    {expand &&
                        data.map((info) => {
                                if (hide.indexOf(info.local) < 0) {
                                    return (
                                        <div
                                            key={randomstring()}
                                            className={"boxBorder flex_auto_column hand center padding_borders resumen_height_100 margin_right_12 margin_bottom_12  " + (info.fuerarango ? 'bg_lipstickligth' : 'bg_pealigth')}
                                            onClick={this.props.handleTooltipOpen(family.nombre, process.codigo, info)}
                                        >
                                            <span className="flex_auto_row c_slate margin_bottom_5">{info.nlocal}</span>
                                            <span className="flex_auto_row c_cool_grey_two margin_bottom_5">{info.fecha.split(' ')[0]}</span>
                                            <span className="flex_auto_row barlow_regular_little c_black ">{info.fecha.split(' ')[1]}</span>
                                        </div>
                                    )
                                }
                                return <div key={randomstring()} />
                            })
                    }
                </div>
            </div>
        )
    }
}

ExpandFamily.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(ExpandFamily);



// WEBPACK FOOTER //
// ./src/components/complex/reports/employee/ExpandProcess.js